import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/sub-categories/create',
    name: 'subCategoryCreate',
    component: () =>
      import('@/views/restricted/manufacturers/category/sub-category/SubCategoryCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_CREATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/sub-categories/:subCategoryId/edit',
    name: 'subCategoryUpdate',
    component: () =>
      import('@/views/restricted/manufacturers/category/sub-category/SubCategoryUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_UPDATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/sub-categories/:subCategoryId',
    name: 'subCategoryDetail',
    component: () =>
      import(
        '@/views/restricted/manufacturers/category/sub-category/SubCategoryDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_READ_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/sub-categories/:subCategoryId/serial-number-models/create',
    name: 'modelSerialNumberCreate',
    component: () =>
      import(
        '@/views/restricted/manufacturers/category/sub-category/model-serial-number/ModelSerialNumberCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_UPDATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/sub-categories/:subCategoryId/serial-number-models/:modelSerialNumberId/edit',
    name: 'modelSerialNumberUpdate',
    component: () =>
      import(
        '@/views/restricted/manufacturers/category/sub-category/model-serial-number/ModelSerialNumberUpdateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_UPDATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  }
]
